import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'use-facility'

const client = new ApiClient(API_NAME)

export default {
  get() {
    return client.get(`/${BASE_PATH}/`)
  },
  getChildren(facilityId) {
    return client.get(`/${BASE_PATH}/${facilityId}/use-child-facility/`)
  }
}
